






























import Vue from 'vue';
import JobResource from '@/api/job/JobResource';
import CycleValidationResource from '@/api/cyclevalidation/CycleValidationResource';
import { JobExecution } from '@/api/processing/JobExecution';
import { Cycle } from '@/types/cycle';
import {
  Component, Prop, Watch, Inject,
} from 'vue-property-decorator';
import moment from 'moment';
import LocalDateTime from '../types/localdatetime';
import { CycleValidationSnapshot } from '../types/cyclevalidationsnapshot';
import { RecompArgument } from '../api/reload/RecompArgument';

@Component
export default class RecompDialog extends Vue {
	@Inject('JobResource')
	jobResource!: JobResource;

	@Inject('CycleValidationResource')
	cycleValidationResource!: CycleValidationResource;

	@Prop({ default: '' }) value: any;

	@Prop() selectedFiId!: number;

	@Prop({ default: false }) disabled: any;

	@Prop() reloadCycles!: Array<Cycle>;

	@Prop() defaultRecompArguments!: RecompArgument[];

	@Prop() parentShowing!: boolean;

	dataLoading = false;

	cyclesLoaded:number = 0;

	includeRecomp = false;

	jobExecutionMap: Map<number, Array<JobExecution>> = new Map<
		number,
		Array<JobExecution>
	>();

	selectedJobExecutionMap: Map<number, number> = new Map<number, number>();

	jobExecutionMapForCycleHasData(cycleId:number) {
	  return this.jobExecutionMap.get(cycleId) !== undefined && this.jobExecutionMap.get(cycleId)!.length > 0;
	}

	@Watch('parentShowing')
	onParentComponentShowing() {
	  if (!this.parentShowing) {
	    this.includeRecomp = false;
	    this.dataLoading = false;
	    this.jobExecutionMap.clear();
	    this.selectedJobExecutionMap.clear();
	  }
	}

	setCycleJobExecution(jobExecutionId: number, cycleId: number) {
	  this.selectedJobExecutionMap.set(cycleId, jobExecutionId);
	  const jobExecutionsForCycle = this.jobExecutionMap.get(cycleId);
	  if (jobExecutionsForCycle) {
	    // this filter should only find 1, so we reference [0] down below
	    const selectedJobExecution = jobExecutionsForCycle.filter(
	      (je: JobExecution) => je.id === jobExecutionId,
	    )[0];
	    this.$emit(
	      'jobExecutionSelectedForCycle',
	      cycleId,
	      jobExecutionId,
	      selectedJobExecution.description,
	    );
	  }
	}

	@Watch('reloadCycles')
	onReloadCyclesChanged() {
	  if (this.reloadCycles && this.reloadCycles.length > 0) {
	    this.jobExecutionMap.clear();
	    this.selectedJobExecutionMap.clear();
	    this.dataLoading = true;
	    this.cyclesLoaded = 0;
	    this.reloadCycles.forEach((cycle) => {
	      this.getQualEndJobExecutions(cycle);
	    });

	    // if the defaultRecompArguments prop has a value, check the checkbox
	    if (this.defaultRecompArguments && this.defaultRecompArguments.length > 0) {
	      this.includeRecomp = true;
	    } else if (this.includeRecomp) {
	    //   this.includeRecomp = false;
	    }
	  }
	}

	@Watch('includeRecomp')
	onIncludeRecomp() {
	  this.$emit('includeRecompToggled', this.includeRecomp);
	  if (this.includeRecomp) {
	    this.selectedJobExecutionMap.forEach((value: number, key: number) => {
	      const jobExecutionsForCycle =					this.jobExecutionMap.get(key) || undefined;
	      if (jobExecutionsForCycle) {
	        const selectedJobExecution = jobExecutionsForCycle.filter(
	          (je: JobExecution) => je.id === value,
	        )[0]; // should be only 1 with that id so we use [0]
	        this.$emit(
	          'jobExecutionSelectedForCycle',
	          key, // key is cycle id
	          value, // value is job execution id
	          selectedJobExecution.description,
	        );
	      }
	    });
	  }
	}

	getQualEndJobExecutions(cycle: Cycle) {
	  this.jobResource
	    .getAllSuccessfulProcessingJobExecutionsForDate(
	      this.getSelectedFiId(),
	      cycle.qualificationEndDate.toString(),
	    )
	    .then((returnedJobExecutions: JobExecution[]) => {
	      /* eslint no-param-reassign: "error" */
	      if (returnedJobExecutions) {
	        // set description of job execution
	        returnedJobExecutions.forEach((currentJobExecution) => {
	          currentJobExecution.description = RecompDialog.getJobExecutionDescription(currentJobExecution);
	        });
	        // set job execution map for cycle
	        this.jobExecutionMap.set(cycle.id, returnedJobExecutions);

	        if (returnedJobExecutions.length === 1) {
	          // default to first one in the list
	          this.selectedJobExecutionMap.set(
	            cycle.id,
	            returnedJobExecutions[0].id,
			  );
	        } else if (returnedJobExecutions.length > 1) {
	          this.updateDescriptionOfValidatedJobExecution(cycle.id, returnedJobExecutions);
	        }
		  }
		  // if there are defaultRecompArguments, set the appropriate job execution as selected
		  if (this.defaultRecompArguments && this.defaultRecompArguments.length > 0) {
			  // eslint-disable-next-line max-len
			  const currentCycleRecompSettings = this.defaultRecompArguments.filter((settings:RecompArgument) => settings.cycleId === cycle.id);
			  if (currentCycleRecompSettings) {
			  	// eslint-disable-next-line max-len
	            this.setCycleJobExecution(currentCycleRecompSettings[0].jobExecutionId, currentCycleRecompSettings[0].cycleId);
			  }
		  }
	      this.cyclesLoaded++;
		  this.checkIfLoadingIsDone();
	    })
	    .catch((error: any) => {
	      console.log(error);
	    });
	}

	checkIfLoadingIsDone() {
	  if (this.cyclesLoaded === this.reloadCycles.length) {
	    this.dataLoading = false;
	  }
	}

	getSelectedFiId() {
	  return this.selectedFiId;
	}

	updateDescriptionOfValidatedJobExecution(cycleId: number, jobExecutionsSortedByStartTime: JobExecution[]) {
		 this.cycleValidationResource.getLatestApprovedCycleValidationSnapshot(this.getSelectedFiId(), cycleId)
	            .then((latestCycleValidationSnapshot: CycleValidationSnapshot) => {
	              if (latestCycleValidationSnapshot !== undefined) {
	        		const validatedJobExecutionId: number = RecompDialog.findValidatedJobExecutionId(
						  jobExecutionsSortedByStartTime, latestCycleValidationSnapshot,

	  				);
	                if (validatedJobExecutionId > 0) {
					  const validatedJobExecution:JobExecution = this.jobExecutionMap.get(cycleId)!
					  			.filter((je: JobExecution) => je.id === validatedJobExecutionId)[0];
					  validatedJobExecution.description = RecompDialog.getJobExecutionDescription(validatedJobExecution, true);
	                }
	              }
	            })
	            .catch((error: any) => {
	      		  // this is most certainly a 404 because no snapshot was APPROVED.
	      		  // log and do nothing.
	         	  console.log(error);
	            });
	}

	static findValidatedJobExecutionId(jobExecutionsSortedByStartTime: JobExecution[],
	  cycleValidationSnapshot: CycleValidationSnapshot): number {
	  let validatedJobExecutionId: number = 0;
	  jobExecutionsSortedByStartTime.reverse().forEach((currentJobExecution) => {
	  	if (moment(currentJobExecution.startTime).isBefore(cycleValidationSnapshot.created)) {
	    	validatedJobExecutionId = currentJobExecution.id;
	    }
	  });
	  return validatedJobExecutionId;
	}

	static getJobExecutionDescription(jobExecution: JobExecution, approvedFlag?: boolean): string {
	  const dateString = new Date(jobExecution.startTime).toLocaleDateString('en-US', { timeZone: 'America/Chicago' });
	  const timeString = new Date(jobExecution.startTime).toLocaleTimeString('en-US', { timeZone: 'America/Chicago' });
	  let description = `${dateString} ${timeString}`;
	  if (approvedFlag) {
		  description += ' ** APPROVED **';
	  }
	  return description;
	}
}
